import * as Selectors from './selectors';
import * as Actions from './actions';

export default {
    Selectors,
    Actions,
};
